import axios from 'axios'
import noopRequestInterceptor from './interceptor/request/noop-request-interceptor'

import normalize from './interceptor/response/normalize'
import error from './interceptor/response/error'
import notifyAfterError from './interceptor/response/notify-after-error'
import printLog from '@/utils/request/interceptor/response/print-log'
import { IS_DEV } from '@/const'
import { authInterceptor } from './interceptor/request/auth'

export const baseURL = IS_DEV ? process.env.VUE_APP_BASE_DEV_API : process.env.VUE_APP_BASE_API

const service = axios.create({
  baseURL,
  timeout: 0
})

// request interceptor
service.interceptors.request.use(
  noopRequestInterceptor.fulfilled,
  noopRequestInterceptor.rejected
)

// 请求头加上 token
service.interceptors.request.use(authInterceptor)


// response interceptor
;[
  printLog,
  normalize,
  error,
  notifyAfterError
].forEach((interceptor) => {
  // axios 定义中，自定义拦截器的参数、响应类型与我们所需要的不一致
  service.interceptors.response.use(
    interceptor.fulfilled as any,
    interceptor.rejected as any
  )
})

export default service
